import { BuilderComponent } from '@builder.io/react'
import { StaticQuery, graphql } from 'gatsby'
import React, { useEffect, useState } from 'react'
import '../../../builder-settings'
import { Amplify } from 'aws-amplify'
import { getCognitoId } from 'components/util/UserId'
import { spoofMode } from 'state/apis/api'
import { setPagePriorityState } from 'utils/priority-storage'
// import { BuilderContext } from 'templates/builder/Page'
import Seo from '../../util/Seo'

//@ts-ignore
import awsconfig from '../../../aws-exports'
Amplify.configure(awsconfig)

const query = graphql`
  query {
    allBuilderModels {
      header(options: { cachebust: true }) {
        content
      }
      footer(options: { cachebust: true }) {
        content
      }
      banner(options: { cachebust: true }) {
        data {
          isActive
          isForLoggedIn
        }
        content
      }
    }
  }
`

function PageLayout({
  children,
  headerIdentifier,
  footerIdentifier,
  activeBannerIdentifier,
  activeLoggedInBannerIdentifier,
  bannerEnable,
  bannerFixed,
  OGData,
  title,
  headerWrapperBackgroundColor
}: any) {
  const [isOnSignUpOrAccount, setIsOnSignUpOrAccount] = useState(false)
  const [paddingSize, _setPaddingSize] = useState<number>()
  const [isSignedIn, setIsSignedIn] = useState(false)

  useEffect(() => {
    setIsOnSignUpOrAccount(window.location.pathname.includes('signup') || window.location.pathname.includes('account'))
  }, [])

  useEffect(() => {
    setPagePriorityState('content', spoofMode)
    // Updates to account if user is logged in
    if (isSignedIn) {
      setPagePriorityState('account', spoofMode)
    }
  }, [isSignedIn])

  useEffect(() => {
    const checkIfSignedIn = async () => {
      const username = await getCognitoId()
      if (username) {
        setIsSignedIn(true)
      } else {
        setIsSignedIn(false)
      }
    }

    document.querySelector('body')?.addEventListener('mouseover', checkIfSignedIn)
    document.querySelector('body')?.addEventListener('touchstart', checkIfSignedIn)

    return () => {
      document.querySelector('body')?.removeEventListener('mouseover', checkIfSignedIn)
      document.querySelector('body')?.removeEventListener('touchstart', checkIfSignedIn)
    }
  }, [])

  return (
    <StaticQuery query={query}>
      {data => {
        const models = data.allBuilderModels

        console.log('PageLayout:: header identifier', headerIdentifier)
        console.log('PageLayout:: footer identifier', footerIdentifier)
        console.log('PageLayout:: banner identifier', activeBannerIdentifier)
        console.log('PageLayout:: headers', models.header)
        console.log('PageLayout:: footer', models.footer)
        console.log('PageLayout:: banners', models.banner)

        const selectedHeader =
          models.header.filter((headerItem: any) => headerItem.content.id === headerIdentifier)[0]?.content ||
          models.header[0]?.content
        const selectedFooter =
          models.footer.filter((footerItem: any) => footerItem.content.id === footerIdentifier)[0]?.content ||
          models.footer[0]?.content

        /**
         * maybe check for active banner property or something like that too here
         */
        let selectedBanner = null

        if (bannerEnable) {
          if (isSignedIn) {
            models.banner.forEach((b: any) => {
              if (b.data.isForLoggedIn) {
                if (b.content.id === activeBannerIdentifier) {
                  selectedBanner = b.content
                }
              }
            })

            if (!selectedBanner) {
              selectedBanner = models.banner.filter((b: any) => b.data.isForLoggedIn)[0]?.content
            }
          } else {
            models.banner.forEach((b: any) => {
              if (!b.data.isForLoggedIn) {
                if (b.content.id === activeBannerIdentifier) {
                  selectedBanner = b.content
                }
              }
            })

            if (!selectedBanner) {
              selectedBanner = models.banner.filter((b: any) => b.data.isForLoggedIn === false)[0]?.content
            }
          }
        }

        console.log('PageLayout:: Found Header', selectedHeader)
        console.log('PageLayout:: Found Footer', selectedFooter)
        console.log('PageLayout:: Found Footer', selectedBanner)

        return (
          <div className="padding-top-for-fixed-header" style={{ paddingTop: `${paddingSize}px` }}>
            <Seo title={title} OGData={OGData} />
            {!isOnSignUpOrAccount && (
              <div className={`${!bannerFixed ? 'header-not-fixed' : 'header-fixed'}`}>
                <BuilderComponent content={selectedBanner} model="banner" />
                <BuilderComponent name="header" content={selectedHeader} />
              </div>
            )}
            <div className="padding-top-for-fixed-header">{children}</div>
            {!isOnSignUpOrAccount && (
              <div>
                <BuilderComponent name="footer" content={selectedFooter} />
              </div>
            )}
          </div>
        )
      }}
    </StaticQuery>
  )
}

export default PageLayout
